import React from 'react'

export const SubScript = ({ text }) => <sub>{text}</sub>

export const SuperScript = ({ text }) => <sup>{text}</sup>
